module.exports = __webpack_public_path__ + "img/pet@2x.1bb92b8c.webp";